module.exports = __webpack_public_path__ + "static/media_coverge-b948b9f1b2a6384ad5367b89adfaac56.jpeg";